import { Locale } from '../../../../i18n-config';

export const DEMO_INTERESTS = ['e-signature', 'ai-engine'] as const;

export type DemoInterest = (typeof DEMO_INTERESTS)[number];

export const demoHref = (lang: Locale, interest: DemoInterest): string => `/${lang}/demo?interest=${interest}`;

export const readDemoInterest = (search: string): DemoInterest | null => {
  const value = new URLSearchParams(search).get('interest');
  return DEMO_INTERESTS.find((interest) => interest === value) ?? null;
};
